import src from "IMAGE";
export default { src, width: 260, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42kXKsQoAERgAYK9569W9wWVxV8RCUfwiizL/g8UDGhT7RwKlsbN7gHlTsw/WfKGUzDvA8QsoZAN9gFILfDyUCYddI1fBUCRrAAAAAElFTkSuQmCC"};
